import React, { cloneElement } from 'react';
import classNames from 'classnames';
import Icon from '../../../design-system/icon.jsx';
import Spinner from '../../../design-system/spinner.jsx';
import { formatCents } from '../../../../utils/money';
import { Quantity } from '../quantity.jsx';

export const CartItem = ({
  checkboxSwitcher,
  defaultPrice,
  discountPrice,
  flavor,
  image,
  itemQuantity,
  itemUrl,
  productTitle,
  variantTitle,
  isQuantityDisabled,
  onAddItem,
  onDecreaseQuantity,
  onIncreaseQuantity,
  onRemoveItem,
  isQuantityPending = false,
  isRemovePending = false,
  isAddPending = false
}) => (
  <div className="cart-popup__item" data-testid="cart-popup-item">
    <div className="cart-popup__item-card">
      <div className="cart-popup__item-img">
        <a {...(itemUrl ? { href: itemUrl } : {})}>
          <img className="lazyload" data-src={image} alt={productTitle} />
        </a>
      </div>
      <div className="cart-popup__item-content">
        <div className="cart-popup__item-info">
          <div className="cart-popup__item-heading">
            <p className="cart-popup__item-product"><b>{productTitle}</b></p>
            {variantTitle && (
              <p className="cart-popup__item-variant">{variantTitle}
                {flavor && (
                  <span>
                    {' '} / {flavor}
                  </span>
                )}
              </p>
            )}
          </div>
          {onRemoveItem && (
            <button
              aria-busy={isRemovePending}
              aria-label="Remove item"
              className={classNames('cart-popup__item-remove-icon', {
                'cart-popup__item-remove-icon--pending': isRemovePending
              })}
              onClick={isRemovePending ? undefined : onRemoveItem}
              type="button"
            >
              {isRemovePending ? <Spinner color="black" inline /> : <Icon type="trash" />}
            </button>
          )}
          {onAddItem && (
            <button
              aria-busy={isAddPending}
              className={classNames('btn btn--primary btn--rounded cart-popup__item-add-to-cart-btn', {
                'cart-popup__item-add-to-cart-btn--pending': isAddPending
              })}
              onClick={isAddPending ? undefined : onAddItem}
              type="button"
            >
              {isAddPending ? <Spinner color="white" inline /> : <span>Add</span>}
            </button>
          )}
        </div>
        <div className={classNames('cart-popup__item-quantity-and-price-content', {
          'cart-popup__item-price-content--with-offset': isQuantityDisabled
        })}>
          {itemQuantity && !isQuantityDisabled && (
            <Quantity
              amount={itemQuantity}
              className="cart-popup__item-quantity"
              isPending={isQuantityPending}
              onDecreaseQuantity={onDecreaseQuantity}
              onIncreaseQuantity={onIncreaseQuantity}
            />
          )}
          <div className='cart-popup__item-price-content'>
            {Boolean(defaultPrice) && discountPrice !== defaultPrice && (
              <p className="cart-popup__item-price cart-popup__item-price--line-through">
                <span className="screenreader">Regular price</span>
                {formatCents(defaultPrice)}
              </p>
            )}
            <p className={classNames('cart-popup__item-price', {
              'cart-popup__item-price--discounted--red': defaultPrice && discountPrice !== defaultPrice,
              'cart-popup__item-price--discounted--black': discountPrice === defaultPrice
            })}>
              {Boolean(defaultPrice) && discountPrice !== defaultPrice && (
                <span className="screenreader">Subscription price</span>
              )}
              <b>{formatCents(discountPrice)}</b>
            </p>
          </div>
        </div>
        {checkboxSwitcher && cloneElement(checkboxSwitcher, {
          className: 'cart-popup__item-checkbox-switcher'
        })}
      </div>
    </div>
  </div>
);
